export default __webpack_public_path__ + "static/media/bg1.2abd2bc6.jpg";